import React from 'react';

import { corporate_landing_path } from '../../routes.js';

const CorporateInquiry = () => {
  return (
    <div className="tw-text-center tw-mt-32 tw-text-subtitle-2 tw-font-sans tw-font-bold tw-text-primary-black">
      Interested in a group or corporate subscription?
      <a
        href={corporate_landing_path()}
        className="tw-ml-4 tw-text-primary-red visited:tw-text-primary-red"
      >
        Inquire here
      </a>
    </div>
  );
};

export default CorporateInquiry;
